import { useEffect, useState } from "react";
import { toast } from "sonner";
import { p, TENANT_KEY, STAFF_KEY } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { KeyRound } from "lucide-react";

/** Ingresso del personale col QR: apre la sessione del locale e passa la parola al tastierino. */
export default function PersonaleEntra() {
  const [errore, setErrore] = useState("");

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("k");
    if (!token) return setErrore("Manca il codice: inquadra di nuovo il QR del locale.");
    p("/tenant/staff-link/use", { token })
      .then((r) => {
        localStorage.setItem(TENANT_KEY, r.token);
        localStorage.removeItem(STAFF_KEY);
        localStorage.removeItem("rh_user");
        toast.success(`${r.tenant?.name || r.slug}: scegli il tuo nome`);
        window.location.replace("/");
      })
      .catch((e) => setErrore(e?.response?.data?.detail || "Codice non più valido: chiedi al titolare quello nuovo."));
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-900 px-4" data-testid="personale-entra">
      <Card className="w-full max-w-sm p-8 text-center">
        <KeyRound className="mx-auto h-8 w-8 text-slate-400" />
        {errore ? (
          <>
            <p className="mt-4 text-sm font-semibold text-rose-700" data-testid="personale-entra-errore">{errore}</p>
            <a href="/entra" className="mt-4 inline-block text-xs font-bold text-slate-600 underline" data-testid="personale-entra-manuale">
              Entro col nome attività e il codice
            </a>
          </>
        ) : (
          <p className="mt-4 text-sm text-slate-500">Un momento: sto aprendo il locale…</p>
        )}
      </Card>
    </div>
  );
}
